// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"270":"resumen","277":"estadisticas","692":"view","934":"plotly"}[chunkId] || chunkId) + "." + {"270":"8e73783c","277":"7850e838","323":"dff4e5f1","692":"da14ab97","934":"7f70dd9c"}[chunkId] + ".js";
};